import React, {Component} from 'react'
import {BrowserRouter, Route, Switch} from 'react-router-dom'
import "./Root.Styles.css"
import MainScreen from "../Main/Main.Screen"
import PrivacyPolicyScreen from "../PrivacyPolicy/PrivacyPolicy.Screen"
import LiabilityWaiver from "../LiabilityWaiver/LiabilityWaiver.Screen"

const TAG = 'Root.Screen.js'

export default class RootScreen extends Component {

  render() {
    return (
      <div className='viewPort'>
        <BrowserRouter>
          <div className='viewRoot'>
            <Switch>
              <Route
                exact
                path='/'
                render={props => (
                  <MainScreen  {...props} />
                )}
              />
              <Route
                exact
                path='/bao-mat-thong-tin'
                render={props => (
                  <PrivacyPolicyScreen {...props} />
                )}
              />
              <Route
                exact
                path='/mien-tru-trach-nhiem'
                render={props => (
                  <LiabilityWaiver {...props} />
                )}
              />
            </Switch>
          </div>
        </BrowserRouter>
      </div>
    )
  }
}
